import { Component, OnInit } from "@angular/core";
import {
  AlertsSettings,
  ClientReportsState,
  ReportsService,
} from "../../services/reports.service";
import { UserService } from "../../domain/user-service";
import { WindowsNotificationService } from "../../services/windows-notification.service";

@Component({
  selector: "alerts",
  templateUrl: "alerts.component.html",
  styleUrls: ["./alerts.component.scss"],
})
export class AlertsComponent implements OnInit {
  public visibleItem: string;
  public reportsState: LocalReportsState;

  constructor(
    private reportsService: ReportsService,
    private userService: UserService,
    private windowsNotificationService: WindowsNotificationService,
  ) {
    this.reportsState = this.localReportsReducer(new ClientReportsState());

    this.visibleItem = "alertTypes";

    this.reportsService.reportsGlobalState.subscribe((newState) => {
      //console.log('Alerts Component: new state',newState);
      this.reportsState = this.localReportsReducer(newState);
    });
  }

  ngOnInit() {}

  toggleSettings() {
    this.visibleItem =
      this.visibleItem === "alertsSettings" ? "alertTypes" : "alertsSettings";
  }

  saveAlertsSettings(updatedAlertsSettings: AlertsSettings) {
    this.userService.getCurrentChannel().then((channel) => {
      updatedAlertsSettings.channelId = channel.id;

      this.reportsService.updateAlertsSettings(updatedAlertsSettings);

      this.toggleSettings();
    });
  }

  showGapReportClicked() {
    if (
      this.reportsState.alertSettings &&
      this.reportsState.alertSettings.gapsReportEnabled
    ) {
      if (this.reportsState.gapsReportStatusText !== "NO ISSUES") {
        this.windowsNotificationService.ACTIONS.showGapReport.next(true);
      }
    } else {
      this.visibleItem = "alertsSettings";
    }
  }

  showMissingSubtitleReportClicked() {
    if (
      this.reportsState.alertSettings &&
      this.reportsState.alertSettings.missingSubtitleReportEnabled
    ) {
      if (this.reportsState.missingSubtitleReportStatusText !== "NO ISSUES") {
        this.windowsNotificationService.ACTIONS.showMissingSubtitlesReport.next(
          true,
        );
      }
    } else {
      this.visibleItem = "alertsSettings";
    }
  }

  showMissingAudiosReportClicked() {
    if (
      this.reportsState.alertSettings &&
      this.reportsState.alertSettings.missingAudiosReportEnabled
    ) {
      if (this.reportsState.missingAudiosReportStatusText !== "NO ISSUES") {
        this.windowsNotificationService.ACTIONS.showMissingAudiosReport.next(
          true,
        );
      }
    } else {
      this.visibleItem = "alertsSettings";
    }
  }

  showEmptyContractsReportClicked() {
    if (
      this.reportsState.alertSettings &&
      this.reportsState.alertSettings.emptyContractReportEnabled
    ) {
      if (this.reportsState.emptyContractsReportStatusText !== "NO ISSUES") {
        this.windowsNotificationService.ACTIONS.showEmptyContractsReport.next(
          true,
        );
      }
    } else {
      this.visibleItem = "alertsSettings";
    }
  }

  localReportsReducer(globalState: ClientReportsState): LocalReportsState {
    const newLocalState = new LocalReportsState();

    if (globalState.reportAlertsSettings) {
      newLocalState.alertSettings = globalState.reportAlertsSettings;

      if (globalState.reportAlertsSettings.gapsReportEnabled) {
        if (globalState.gapsCount > 0) {
          newLocalState.gapsReportStatusText = `${globalState.gapsCount} ERRORS`;
        } else {
          newLocalState.gapsReportStatusText = `NO ISSUES`;
        }
      }

      if (globalState.reportAlertsSettings.missingSubtitleReportEnabled) {
        if (globalState.missingSubtitlesCount > 0) {
          newLocalState.missingSubtitleReportStatusText = `${globalState.missingSubtitlesCount} ERRORS`;
        } else {
          newLocalState.missingSubtitleReportStatusText = `NO ISSUES`;
        }
      }

      if (globalState.reportAlertsSettings.missingAudiosReportEnabled) {
        if (globalState.missingAudiosCount > 0) {
          newLocalState.missingAudiosReportStatusText = `${globalState.missingAudiosCount} ERRORS`;
        } else {
          newLocalState.missingAudiosReportStatusText = `NO ISSUES`;
        }
      }

      if (globalState.reportAlertsSettings.emptyContractReportEnabled) {
        if (globalState.emptyContractCount > 0) {
          newLocalState.emptyContractsReportStatusText = `${globalState.emptyContractCount} ERRORS`;
        } else {
          newLocalState.emptyContractsReportStatusText = `NO ISSUES`;
        }
      }
    } else {
      newLocalState.forceShowSettings = true;
    }

    return newLocalState;
  }
}

class LocalReportsState {
  public forceShowSettings: boolean;

  public missingSubtitleReportStatusText: string;
  public missingAudiosReportStatusText: string;
  public emptyContractsReportStatusText: string;
  public gapsReportStatusText: string;

  public alertSettings: AlertsSettings;

  constructor() {
    this.missingSubtitleReportStatusText = "DISABLED";
    this.gapsReportStatusText = "DISABLED";
    this.missingAudiosReportStatusText = "DISABLED";
    this.emptyContractsReportStatusText = "DISABLED";

    this.alertSettings = null;
    this.forceShowSettings = false;
  }
}
